export enum DataEntryMode {
  NEW = 'new',
  EDIT = 'edit',
}
